// extracted by mini-css-extract-plugin
module.exports = {"subheaderSkeleton":"App_subheaderSkeleton_2PiPh","iconNoConnection":"App_iconNoConnection_3Ty9z","backToTop":"App_backToTop_3aBSt"};